import { MijnRoute } from '../../mijn-navigatie.model';

export const MORTGAGE_INCREASE: MijnRoute = {
    path: 'hypotheken-verhogen',
    navigationEvent: 'toHypothekenVerhogen',
    regex: /^\/hypotheek\/hypotheken-verhogen$/,
    webcomponent: 'mijn-hypotheken-verhogen-webcomponent'
};
